/**
 * ページ初期化ユーティリティ
 * 複数の初期化関数を統一されたパターンで管理
 */

(function() {
    'use strict';

    /**
     * ページ初期化関数
     * @param {Array|Function} initFunctions - 初期化関数の配列、または単一の関数
     */
    function initPage(initFunctions) {
        // 単一の関数が渡された場合は配列に変換
        if (typeof initFunctions === 'function') {
            initFunctions = [initFunctions];
        }

        // 配列でない場合は何もしない
        if (!Array.isArray(initFunctions)) {
            return;
        }

        // DOMContentLoadedまたは即座に実行
        const ready = function() {
            initFunctions.forEach(function(fn) {
                if (typeof fn === 'function') {
                    try {
                        fn();
                    } catch (error) {
                        console.error('Page initialization error:', error);
                    }
                }
            });
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', ready);
        } else {
            ready();
        }
    }

    // グローバルに公開
    window.initPage = initPage;
})();

